import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import StyledModal from "components/Modal";
import WarningBox from "components/WarningBox";

import { useAppDispatch } from "store/hooks";
import {
  BankToken,
  deleteBankIntegration,
  getBankIntegrations,
} from "store/features/bankIntegrationsSlice";

interface IntegrationDeleteModalProps {
  isOpen: boolean;
  bankToken: BankToken | null;
  onClose: () => void;
}

const IntegrationDeleteModal: React.FC<IntegrationDeleteModalProps> = (
  props
) => {
  const { isOpen, bankToken, onClose } = props;
  const dispatch = useAppDispatch();

  const onSubmit = async () => {
    bankToken?.bankTokenUid &&
      (await dispatch(deleteBankIntegration(bankToken.bankTokenUid)).unwrap());
    await dispatch(getBankIntegrations()).unwrap();
    onCloseModal();
  };

  const onCloseModal = () => {
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onCloseModal}
      title="Видалити інтеграцію"
      content={
        <>
          <WarningBox content="Цю дію не можна скасувати." />
          <Box
            sx={{
              borderRadius: 1,
              border: "1px solid #E5E5E5",
              p: "12px 16px",
              m: "16px 0",
            }}
          >
            <Typography variant="subtitle2" color="grey800" sx={{ mb: 0.5 }}>
              Назва
            </Typography>
            <Typography
              variant="body2"
              sx={{ overflowWrap: "anywhere" }}
              data-posthog-mask="true"
            >
              {bankToken?.name || ""}
            </Typography>
            <Box sx={{ m: "12px 0", border: "1px solid #E5E5E5" }} />
            <Typography variant="subtitle2" color="grey800" sx={{ mb: 0.5 }}>
              Банк
            </Typography>
            <Typography variant="body2">
              {bankToken?.bank?.name || ""}
            </Typography>
          </Box>
        </>
      }
      onAction={onSubmit}
      actionBtnText="Видалити"
      actionBtnColor="error"
      actionBtnBorder
    />
  );
};

export default IntegrationDeleteModal;
